import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { MakingDataService } from '../../md/service/making-data.service';
import { Mainservice2Service } from './mainservice2.service';
import { TokenService } from '../../token.service';
import * as numberToWords from 'number-to-words';

@Injectable({
  providedIn: 'root'
})
export class KlManageService {

  httpUrl: any;
  erpUser: any;
  b_acct_id: any;
  file_id:any;
  URL :any;
  Obj : any = {};
  data_status : boolean = true;
  role_bill:boolean = false;
  setData(url:any){
    this.URL = url;
  }
  constructor(private http: HttpClient, private main: Mainservice2Service, private token: TokenService,
    private sanitizer: DomSanitizer, private mds: MakingDataService) {
    this.httpUrl = this.main.httpUrl;
  }

  async insertkalyanmandapdata(obj: any) {
    const resp = this.http.post<any>(this.main.httpUrl2 + '/klm/kalyanmandapdetails/insertkalyanmandapdata', obj).toPromise().then(res => {
      return res
    });
    return resp
  }
  async getdata(obj: any) {
    const resp = this.http.get<any>(this.main.httpUrl2 + '/klm/kalyanmandapdetails/getdata' +  obj).toPromise().then(res => {
      return res
    });
    return resp
  }

  async getklmdatabyid(obj: any) {
    const resp = this.http.get<any>(this.main.httpUrl2 + '/klm/kalyanmandapdetails/getklmdatabyid' +  obj).toPromise().then(res => {
      return res
    });
    return resp
  }

  async getklmbookingdata(obj: any) {
    const resp = this.http.get<any>(this.main.httpUrl2 + '/klm/kalyanmandapdetails/getklmbookingdata' +  obj).toPromise().then(res => {
      return res
    });
    return resp
  }

  
  async getbookingdtls(obj: any) {
    const resp = this.http.get<any>(this.main.httpUrl2 + '/klm/kalyanmandapdetails/getbookingdtls' +  obj).toPromise().then(res => {
      return res
    });
    return resp
  }
  async getbookingimage(obj: any) {
    const resp = this.http.get<any>(this.main.httpUrl2 + '/klm/kalyanmandapdetails/getbookingimage' +  obj).toPromise().then(res => {
      return res
    });
    return resp
  }


  async getdocument(obj: any) {

    console.log(obj)
    const resp = await this.http.post(this.main.httpUrl2  + '/klm/kalyanmandapdetails/getdocument', obj, { responseType: 'blob' }).toPromise().then(res => {
      return res;
    });
    if (resp) {
      return resp;
    }
    return
  }

  async deactivateklm(obj: any) {
    const resp = this.http.put<any>(this.main.httpUrl2 + '/klm/kalyanmandapdetails/deactivateklm' ,  obj).toPromise().then(res => {
      return res
    });
    return resp
  }

  async ggetbookingdasboardpiechartdata(obj: any) {
    const resp = this.http.get<any>(this.main.httpUrl2 + '/klm/kalyanmandapdetails/getbookingdasboardpiechartdata' +  obj).toPromise().then(res => {
      return res
    });
    return resp
  }
  async  getDashboardLineChart(obj:any) {
    const resp = this.http.get<any>(this.main.httpUrl2 + '/klm/kalyanmandapdetails/getDashboardLineChart' + JSON.stringify(obj)).toPromise().then(res => {
      return res
    });
    return resp
  }
  async updateklmdetails(obj: any) {
    const resp = this.http.put<any>(this.main.httpUrl2 + '/klm/kalyanmandapdetails/updateklmdetails' ,  obj).toPromise().then(res => {
      return res
    });
    return resp
  }

}
